// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"227":"4522b4db8e48d827","709":"1ee25344c06bf73c"}[chunkId] + ".css";
};